export default {
	cinema: {
		address: 'г. Якутск, пр-т Ленина, 12',
		place: null,
		phoneNumbers: [],
		facebook: null,
		instagram: null,
		vk: null,
		twitter: null,
		odnoklassniki: null,
		youtube: null,
		app: {
			appstore: null,
			googleplay: null,
		},
		payment: {
			active: true,
			card: ['mir', 'visa', 'mastercard', 'maestro', 'sbp', 'sberpay'],
		},
		maps: null,
		selectButton: {
			options: [
				{
					value: 'https://kinocenterykt.ru',
					title: 'Центральный',
				},
				{
					value: 'https://aviator.kinocenterykt.ru',
					title: 'Авиатор',
				},
				{
					value: 'https://rossia.kinocenterykt.ru',
					title: 'Россия',
				},
			],
			selectedOptionValue: 'https://kinocenterykt.ru',
		},
		soonPageIsEnabled: false,
		saleRules: false,
		details: false,
	},
	feedback: true,
};
